import { AxiosError } from 'axios';

import { axiosInstance } from '../assets/utils/axiosInstance';

interface ErrorResponse {
  message: string;
}

const googleTOTPService = {
  // Activate Google Totp Service for CUSTOMER ACCOUNT
  enableCustomerGoogleTOTPService: async (authenticatorCode?: string) => {
    try {
      const backupCode = await axiosInstance().post('/tenant/totp/activate/confirm', {
        code: authenticatorCode,
      });
      return backupCode;
    } catch (error) {
      const axiosError = error as AxiosError<ErrorResponse>;
      throw axiosError;
    }
  },

  // Activate Google Totp Service for WHISTLEBLOWER Account
  enableWhistleblowerGoogleTOTPService: async (authenticatorCode?: string) => {
    try {
      const backupCode = await axiosInstance().post('/totp/activate/confirm', {
        code: authenticatorCode,
      });
      return backupCode;
    } catch (error) {
      const axiosError = error as AxiosError<ErrorResponse>;
      throw axiosError;
    }
  },
};

export default googleTOTPService;
